import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstPagoCobro = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_pago_cobro', 
        name: 'Listado de Pagos y Cobros', 
        component: ViewLstPagoCobro,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
